/**
 * Compatibility shim for `next/config`.
 *
 * Next 16 removed `next/config` and `publicRuntimeConfig`. This keeps the
 * `getConfig().publicRuntimeConfig` call shape working so the ~15 existing call
 * sites don't have to change, while the values themselves now come from
 * `lib/runtime-config` — read at request time rather than inlined at build
 * time, so one container image can serve every environment.
 *
 * New code should import `lib/runtime-config` directly.
 */

import getRuntimeConfig, { type RuntimeConfig } from './runtime-config';

export type PublicRuntimeConfig = RuntimeConfig;

interface NextConfig {
  publicRuntimeConfig: PublicRuntimeConfig;
  serverRuntimeConfig: Record<string, unknown>;
}

/**
 * Mimics the old `getConfig()` from `next/config`.
 */
export default function getConfig(): NextConfig {
  return {
    publicRuntimeConfig: getRuntimeConfig(),
    serverRuntimeConfig: {},
  };
}
